import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import apiMiddleware from 'middlewares/api';
import formMiddleware from 'middlewares/form';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers/index';

const logger = createLogger({
  level: 'info',
  collapsed: false,
});

/* globals __DEV__ */
let createStoreWithMiddleware;

const isOfferPage = true;

if (__DEV__) {
  createStoreWithMiddleware = compose(
    applyMiddleware(
      thunkMiddleware.withExtraArgument(isOfferPage),
      apiMiddleware,
      formMiddleware),
    applyMiddleware(logger)
  )(createStore);
} else {
  createStoreWithMiddleware = compose(
    applyMiddleware(
      thunkMiddleware.withExtraArgument(isOfferPage),
      apiMiddleware,
      formMiddleware,
    )
  )(createStore);
}

/**
 * Create a preconfigured store with middlewares
 */
export default function configureStore(initialState) {
  if(window.__INITIAL_STATE__) {
    initialState = window.__INITIAL_STATE__;
  }
  return createStoreWithMiddleware(rootReducer, initialState);
}



// WEBPACK FOOTER //
// ./src/product/store/ConfigStore.js